<template>
  <div>
    <div v-if="billingAddress != ''">
      <b><span class="company-info bill-title">{{ titleAddress }}</span></b>
    </div>
    <div>
      <span class="company-info">{{ billingAddressLine1 }}</span>
    </div>
    <div>
      <span class="company-info">{{ billingAddressLine2 }}</span>
    </div>
    <div>
      <span class="company-info">{{ billingAddressLine3 }}</span>
    </div>

    <div v-if="shippingAddress != ''">
      <b><span class="company-info bill-title">{{ titleAddress2 }}</span></b>
    </div>
    <div>
      <span class="company-info">{{ shippingAddressLine1 }}</span>
    </div>
    <div>
      <span class="company-info">{{ shippingAddressLine2 }}</span>
    </div>
    <div>
      <span class="company-info">{{ shippingAddressLine3 }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    billingAddress: {
      type: Object,
      default: () => {},
    },
    shippingAddress: {
      type: Object,
      default: () => {},
    },
    titleClass:{
      type: String,
      default: ''
    }
  },
  computed: {
    billingAddressLine1() {
      return this.billingAddress?.street;
    },
    billingAddressLine2() {
      return this.billingAddress?.state?.name;
    },
    billingAddressLine3() {
      return `${this.billingAddress?.city}, ${this.billingAddress && this.billingAddress?.postalCode.toUpperCase()}`;
    },
    shippingAddressLine1() {
      return this.shippingAddress?.street;
    },
    shippingAddressLine2() {
      return this.shippingAddress?.state?.name;
    },
    shippingAddressLine3() {
      return `${this.shippingAddress?.city}, ${this.shippingAddress && this.shippingAddress?.postalCode.toUpperCase()}`;  
    },
    titleAddress() {
      if(this.billingAddress?.type?.code == 'BILLING'){
        return this.$i18n.t(`users.deliveryAddress.billingAddress`);
      }
      return '';
    },
    titleAddress2() { 
      if(this.shippingAddress?.type?.code == 'SHIPPING'){
        return this.$i18n.t(`users.deliveryAddress.deliveryAddress`);
      }
      return '';
    },
    previousPageBtnLabel() {
      return this.$i18n.t(`common.previousPageBtn.${this.labelCode}`);
    },
  },
  methods: {},
};
</script>
<style scoped>
.bill-title{
  font-size: 18px !important;
  font-weight: 400 !important;
}
.bill-title-wrapper{
  margin-bottom: 8px;
}
</style>